import { useCallback, useState } from 'react';
import { NetworkAddressRegex } from '@libs/backend-common';
export const useValidateWalletAddress = (errorMessage) => {
    const [addressFormatError, setAddressFormatError] = useState();
    const validateWalletAddress = useCallback((selectedNetworkId, address) => {
        if (selectedNetworkId && address !== '') {
            const foundRegex = NetworkAddressRegex[selectedNetworkId];
            const regex = new RegExp(foundRegex);
            if (foundRegex && !regex.test(address)) {
                setAddressFormatError(errorMessage);
            }
            else {
                setAddressFormatError('');
            }
        }
        else {
            setAddressFormatError(undefined);
        }
    }, [errorMessage]);
    return {
        validateWalletAddress,
        addressFormatError,
    };
};
//# sourceMappingURL=useValidateWalletAddress.js.map